import {
  QueueInfoIcon,
  QueueSuccessIcon,
  QueueWarningStatusIcon,
} from "@/components/icons";

type QueueStatusPillProps = {
  tone: "success" | "warning" | "info";
  title: string;
  text: string;
};

const toneClasses = {
  // success: "bg-[#42bd4f] text-white",
  success: "bg-[#2d8c15] text-white",
  warning: "bg-[#fec822] text-black",
  info: "bg-[#36b5df] text-black",
};

export function QueueStatusPill({ tone, title, text }: QueueStatusPillProps) {
  return (
    <div
      className={`mt-[10px] flex min-h-[34px] items-center justify-center h-[70px] text-center gap-[8px] rounded-sm px-[10px] py-[6px] ${toneClasses[tone]}`}
    >
      {/*<StatusIcon tone={tone} />*/}
      <p className="text-[12px] font-medium leading-[1.1]">
        <strong className={`${tone === "success" ? "block" : ""} font-black`}>
          {title}
          <br />
        </strong>
        {tone !== "success" && " "}
        {text}
      </p>
    </div>
  );
}

function StatusIcon({ tone }: Pick<QueueStatusPillProps, "tone">) {
  if (tone === "success") {
    return <QueueSuccessIcon className="h-[24px] w-[24px] shrink-0" />;
  }

  return tone === "warning" ? (
    <QueueWarningStatusIcon className="h-[24px] w-[24px] shrink-0" />
  ) : (
    <QueueInfoIcon className="h-[24px] w-[24px] shrink-0" />
  );
}
